import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import '../../styles/event.css';
import { choose } from '../../utils/platform';
import { useFunctions } from './useFunctions';
import FunctionsDesktop from './Functions.desktop';
import FunctionsMobile from './Functions.mobile';

const FunctionsView = choose(FunctionsDesktop, FunctionsMobile);

function FunctionsInner({ event }) {
  const vm = useFunctions(event);
  return <FunctionsView vm={vm} />;
}

export default function Functions() {
  return <RequireEvent>{(event) => <FunctionsInner event={event} />}</RequireEvent>;
}
